import React, { useRef } from "react"
import { Modal, ModalDialog, ModalProps } from "react-bootstrap"
import Draggable from "react-draggable"

const DraggableModalInner: React.FC<ModalProps> = (props) => {
  const draggableRef = useRef<Draggable | null>(null)
  const nodeRef = useRef<HTMLElement>(null)

  return (
    <Draggable
      ref={draggableRef}
      // draggable対象となるノードと接続
      nodeRef={nodeRef}
      defaultClassName="draggable-modal-cubic-bezier"
      handle=".modal-header"
      onStart={(e, data) => {
        // 以下を記載することで他のDraggableが動かないようになる
        e.preventDefault()
        e.stopPropagation()
      }}
      onStop={(e, data) => {
        const casted: any = e
        const castedWindow = e.view as Window

        let isOutOfBounds = false

        if (casted.x < 50) {
          isOutOfBounds = true
        } else {
          if (castedWindow.innerWidth - 50 < casted.x) {
            isOutOfBounds = true
          }
        }
        if (casted?.y < 50) {
          isOutOfBounds = true
        } else {
          if (castedWindow.innerHeight - 50 < casted?.y) {
            isOutOfBounds = true
          }
        }

        // 場外に出てしまった場合は戻せないため中心に戻す
        if (isOutOfBounds) {
          if (draggableRef.current != null) {
            draggableRef.current?.setState({
              ...draggableRef.current.state,
              dragging: false,
              dragged: false,
              x: 0,
              y: 0,
            })
          }
        }
      }}>
      <ModalDialog
        {...props}
        // 型が合わないのでany対応
        ref={nodeRef as any}>
        {props.children}
      </ModalDialog>
    </Draggable>
  )
}

const DraggableModal: React.FC<ModalProps> = (props) => {
  return (
    <Modal dialogAs={DraggableModalInner} {...props}>
      {props.children}
    </Modal>
  )
}

export default DraggableModal
